import { Trigger, TriggerCategory } from '../types';

export const defaultTriggers: Trigger[] = [
  // Environmental Triggers
  {
    id: 'temperature',
    name: 'Temperature',
    category: TriggerCategory.Environmental,
    field: 'temperature',
    label: 'Temperature (°C)',
    type: 'number',
    unit: '°C'
  },
  {
    id: 'humidity',
    name: 'Humidity',
    category: TriggerCategory.Environmental,
    field: 'humidity',
    label: 'Humidity (%)',
    type: 'number',
    unit: '%'
  },
  {
    id: 'weather',
    name: 'Weather Condition',
    category: TriggerCategory.Environmental,
    field: 'weather',
    label: 'Weather',
    type: 'select',
    options: [
      { value: 'sunny', label: 'Sunny' },
      { value: 'rainy', label: 'Rainy' },
      { value: 'snowy', label: 'Snowy' },
      { value: 'cloudy', label: 'Cloudy' },
      { value: 'stormy', label: 'Stormy' }
    ]
  },
  {
    id: 'airQuality',
    name: 'Air Quality Index',
    category: TriggerCategory.Environmental,
    field: 'airQuality',
    label: 'Air Quality',
    type: 'select',
    options: [
      { value: 'good', label: 'Good (0-50)' },
      { value: 'moderate', label: 'Moderate (51-100)' },
      { value: 'unhealthy_sensitive', label: 'Unhealthy for Sensitive (101-150)' },
      { value: 'unhealthy', label: 'Unhealthy (151-200)' },
      { value: 'very_unhealthy', label: 'Very Unhealthy (201-300)' },
      { value: 'hazardous', label: 'Hazardous (301+)' }
    ]
  },
  {
    id: 'season',
    name: 'Season',
    category: TriggerCategory.Environmental,
    field: 'season',
    label: 'Season',
    type: 'select',
    options: [
      { value: 'spring', label: 'Spring' },
      { value: 'summer', label: 'Summer' },
      { value: 'autumn', label: 'Autumn' },
      { value: 'winter', label: 'Winter' }
    ]
  },

  // Time Triggers
  {
    id: 'frequency',
    name: 'Frequency',
    category: TriggerCategory.Time,
    field: 'frequency',
    label: 'Frequency',
    type: 'select',
    options: [
      { value: 'daily', label: 'Daily' },
      { value: 'weekly', label: 'Weekly' },
      { value: 'biweekly', label: 'Every 2 Weeks' },
      { value: 'monthly', label: 'Monthly' },
      { value: 'quarterly', label: 'Quarterly' },
      { value: 'yearly', label: 'Yearly' }
    ]
  },
  {
    id: 'dayOfWeek',
    name: 'Day of Week',
    category: TriggerCategory.Time,
    field: 'dayOfWeek',
    label: 'Day of Week',
    type: 'select',
    options: [
      { value: 1, label: 'Monday' },
      { value: 2, label: 'Tuesday' },
      { value: 3, label: 'Wednesday' },
      { value: 4, label: 'Thursday' },
      { value: 5, label: 'Friday' },
      { value: 6, label: 'Saturday' },
      { value: 0, label: 'Sunday' }
    ]
  },
  {
    id: 'timeOfDay',
    name: 'Time of Day',
    category: TriggerCategory.Time,
    field: 'timeOfDay',
    label: 'Time of Day',
    type: 'select',
    options: [
      { value: 'morning', label: 'Morning (6:00-12:00)' },
      { value: 'afternoon', label: 'Afternoon (12:00-18:00)' },
      { value: 'evening', label: 'Evening (18:00-22:00)' },
      { value: 'night', label: 'Night (22:00-6:00)' }
    ]
  },
  {
    id: 'monthOfYear',
    name: 'Month',
    category: TriggerCategory.Time,
    field: 'monthOfYear',
    label: 'Month',
    type: 'select',
    options: [
      { value: 1, label: 'January' },
      { value: 2, label: 'February' },
      { value: 3, label: 'March' },
      { value: 4, label: 'April' },
      { value: 5, label: 'May' },
      { value: 6, label: 'June' },
      { value: 7, label: 'July' },
      { value: 8, label: 'August' },
      { value: 9, label: 'September' },
      { value: 10, label: 'October' },
      { value: 11, label: 'November' },
      { value: 12, label: 'December' }
    ]
  },
  {
    id: 'daysSinceEvent',
    name: 'Days Since Event',
    category: TriggerCategory.Time,
    field: 'daysSinceEvent',
    label: 'Days Since Event',
    type: 'number',
    unit: 'days'
  },

  // Metric Triggers
  {
    id: 'petAge',
    name: 'Pet Age',
    category: TriggerCategory.Metric,
    field: 'petAge',
    label: 'Pet Age (years)',
    type: 'number',
    unit: 'years'
  },
  {
    id: 'petWeight',
    name: 'Pet Weight',
    category: TriggerCategory.Metric,
    field: 'petWeight',
    label: 'Pet Weight (kg)',
    type: 'number',
    unit: 'kg'
  },
  {
    id: 'weightChange',
    name: 'Weight Change',
    category: TriggerCategory.Metric,
    field: 'weightChange',
    label: 'Weight Change (%)',
    type: 'number',
    unit: '%'
  },
  {
    id: 'activityLevel',
    name: 'Activity Level',
    category: TriggerCategory.Metric,
    field: 'activityLevel',
    label: 'Activity Level',
    type: 'select',
    options: [
      { value: 'very_low', label: 'Very Low' },
      { value: 'low', label: 'Low' },
      { value: 'moderate', label: 'Moderate' },
      { value: 'high', label: 'High' },
      { value: 'very_high', label: 'Very High' }
    ]
  },
  {
    id: 'dailySteps',
    name: 'Daily Steps',
    category: TriggerCategory.Metric,
    field: 'dailySteps',
    label: 'Daily Steps',
    type: 'number',
    unit: 'steps'
  },
  {
    id: 'caloriesConsumed',
    name: 'Calories Consumed',
    category: TriggerCategory.Metric,
    field: 'caloriesConsumed',
    label: 'Calories Consumed',
    type: 'number',
    unit: 'kcal'
  },
  {
    id: 'waterIntake',
    name: 'Water Intake',
    category: TriggerCategory.Metric,
    field: 'waterIntake',
    label: 'Water Intake (ml)',
    type: 'number',
    unit: 'ml'
  },
  {
    id: 'sleepHours',
    name: 'Sleep Hours',
    category: TriggerCategory.Metric,
    field: 'sleepHours',
    label: 'Sleep Hours',
    type: 'number',
    unit: 'hours'
  },
  {
    id: 'heartRate',
    name: 'Heart Rate',
    category: TriggerCategory.Metric,
    field: 'heartRate',
    label: 'Heart Rate (bpm)',
    type: 'number',
    unit: 'bpm'
  },
  {
    id: 'vaccinationDue',
    name: 'Vaccination Due',
    category: TriggerCategory.Metric,
    field: 'vaccinationDue',
    label: 'Vaccination Due In (days)',
    type: 'number',
    unit: 'days'
  },
  {
    id: 'vetCheckDue',
    name: 'Vet Check Due',
    category: TriggerCategory.Metric,
    field: 'vetCheckDue',
    label: 'Vet Check Due In (days)',
    type: 'number',
    unit: 'days'
  },
  {
    id: 'dailyActivity',
    name: 'Daily Activity',
    category: TriggerCategory.Metric,
    field: 'dailyActivity',
    label: 'Daily Activity (minutes)',
    type: 'number',
    unit: 'minutes'
  },
  {
    id: 'litterBoxCleaning',
    name: 'Litter Box Cleaning',
    category: TriggerCategory.Metric,
    field: 'litterBoxCleaning',
    label: 'Days Since Last Cleaning',
    type: 'number',
    unit: 'days'
  }
];